import { _axios} from "../axios";
import { AxiosPromise } from "axios";

/**
 * Gets all barcodes associated with a product
 *
 * @param productSlug
 * @returns {AxiosPromise<any>}
 */
export function getProductBarcodes(productSlug = '') {
    return _axios.get('/products/' + productSlug + '/barcodes');
}

/**
 * Links a barcode with a product
 *
 * @param productSlug String
 * @param barcode
 * @returns {AxiosPromise<any>}
 */
export function storeProductBarcode( productSlug = '', barcode={}) {
    return _axios.post( '/products/' + productSlug + '/barcodes', barcode);
}

/**
 * Remove a barcode from a product
 *
 * @param productSlug
 * @param barcodeSlug
 * @returns {AxiosPromise<any>}
 */
export function destroyProductBarcode( productSlug = '', barcodeSlug = '') {
    return _axios.delete( '/products/' + productSlug + '/barcodes/' + barcodeSlug);
}